module.exports = __webpack_public_path__ + "img/logo.851e766a.png";